import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["container", "sentinel"];

  connect() {
    this.offset = 20;
    this.loading = false;
    this.hasMore = true;

    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this.loadMore();
      }
    });

    this.observer.observe(this.sentinelTarget);
  }

  disconnect() {
    if (this.observer && this.hasSentinelTarget) {
      this.observer.unobserve(this.sentinelTarget);
    }
  }

  loadMore() {
    if (this.loading) return;
    this.loading = true;

    const {
      accountId,
      boardId,
      clientId,
      projectTagId,
      orderBy,
      archived,
      view,
      query,
      accountMemberId: peopleId
    } = this.element.dataset;

    const clientIds = this.safeParseArray(clientId);
    const projectTagIds = this.safeParseArray(projectTagId);

    const baseUrl = this.buildBaseUrl({ accountId, boardId, clientId, peopleId, view });
    const params = new URLSearchParams({
      ...(orderBy && { order_by: orderBy }),
      ...(archived && { archived }),
      ...(query && { q: query }),
      ...(view === 'client_projects' && { board_id: boardId }),
      offset: this.offset
    });

    clientIds.forEach(id => params.append("client_id[]", id));
    projectTagIds.forEach(id => params.append("project_tag_id[]", id));
    const fullUrl = `${baseUrl}?${params.toString()}`;
    let body = document.querySelector("body");
    let flashMessage = document.querySelector(".flash-message");
    if (flashMessage) {
      flashMessage.addClass("sticky-flash");
      flashMessage.innerHTML = "Loading projects ... Please wait !!";
    } else {
      body.insertAdjacentHTML("afterbegin", "<div class=\"flash-message sticky-flash notice\">Loading projects... Please wait!</div>");
      // Reassign to the newly created flash message
      flashMessage = document.querySelector(".flash-message");
    }

    fetch(fullUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(res => res.json())
      .then(data => this.handleLoadMoreResponse(data, flashMessage))
      .catch(error => console.error("Error loading more projects:", error))
      .finally(() => {
        this.loading = false;
      });
  }

  buildBaseUrl({ accountId, boardId, clientId, peopleId, view }) {
    switch (view) {
      case 'board':
        return `/${accountId}/boards/${boardId}/load_more_projects`;
      case 'everything':
        return `/${accountId}/boards/all/load_more_projects`;
      case 'client_projects':
        return `/${accountId}/clients/${clientId}/load_more_projects`;
      case 'account_member':
        return `/${accountId}/people/${peopleId}/load_more_projects`;
      default:
        console.warn('Unknown view:', view);
        return;
    }
  }

  handleLoadMoreResponse(data, flashMessage) {
    this.containerTarget.insertAdjacentHTML("beforeend", data.html);
    if (!data.more_projects) {
      this.hasMore = false;
      this.observer.unobserve(this.sentinelTarget);
    }
    this.offset += 20;
    flashMessage.remove();
  }

  safeParseArray(value) {
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}